const REGISTER_OF_DIRECTORS_DOCUMENT_TYPES = {
  REGISTER_OF_DIRECTORS: {
    value: "register_of_directors",
    readableName: "Register of Directors",
  },
  OTHER: {
    value: "other",
    readableName: "Other",
  },
};

export const registerOfDirectorsDocumentTypesArray = Object.values(
  REGISTER_OF_DIRECTORS_DOCUMENT_TYPES,
);
